import React from 'react';
import { Redirect } from 'react-router-dom';

import { Urls } from 'urls';

const Register = () => <Redirect to={Urls.login} />;

export default Register;
